
import Vue from 'vue';

import HitContext from '@/pages/search/results/table/HitContext.vue';
import { ColumnDefs, DisplaySettingsForRendering, HitRowData } from './table-layout';

import GlossField from '@/pages/search/form/concept/GlossField.vue';

export default Vue.component('HitRow', {
	components: {
		GlossField,
		HitContext
	},
	props: {
		row: Object as () => HitRowData,
		cols: Object as () => ColumnDefs,
		info: Object as () => DisplaySettingsForRendering,
		open: Boolean,

		// which match infos (capture/relation) should be highlighted because we're hovering over a token? (parallel corpora)
		hoverMatchInfos: {
			type: Array as () => string[],
			default: () => [],
		},
	},
	methods: {
		hover(v: any) { this.$emit('hover', v); },
		unhover(v: any) { this.$emit('unhover', v); },
	}
});
